<template>
  <vue-scroll>
    <rabbey-toolbox :filterables="false">
      <!-- <div class="mr-5">
        <el-select
          v-model="type"
          placeholder="Tipo"
          class="box-item"
          size="mini"
        >
          <el-option value="Cantidad">Cantidad</el-option>
          <el-option value="Monto">Monto</el-option>
        </el-select>
      </div> -->
      <el-select
        v-model="option"
        placeholder="Seleccione la opcion"
        class="box-item"
        size="mini"
        @change="handlerChanges"
        clearable
      >
        <el-option
          v-for="item in types"
          :key="item.value"
          :label="item.label"
          :value="item.value"
        ></el-option>
      </el-select>
      <div class="mr-5">
        <yearcomponent
          ref="yearSelector"
          @change="handleryear"
          :initial="2014"
          class="box-item"
          size="mini"
        />
      </div>
    </rabbey-toolbox>

    <el-row>
      <el-col>
        <el-card>
          <h3>Clientes sin Visitar por mes</h3>

          <RabbeyTable3
            ref="table_new"
            v-loading="table_new_loading"
            :columns="columnsNew"
            :data="missingCall"
            :height="350"
            show-summary
          />
        </el-card>
      </el-col>
    </el-row>

    <!-- //drawer -->
    <detalles ref="detalles" />
  </vue-scroll>
</template>

<script>
import yearcomponent from "@/components/Global_System/YearsComponent";
import { formatMonto } from "@/utils";
import CancelHyperLink from "@/components/functionals/CancelHyperLink.vue";
import detalles from "./ClientWithoutCallingDetails";

import RabbeyTable3 from "@/components/RabbeyTable3.vue";

export default {
  name: "ClientWithoutCalling",
  components: {
    yearcomponent,
    detalles,
    RabbeyTable3
  },
  mounted() {
    const yearNow = new Date().getFullYear();
    this.$refs.yearSelector.$data.Year = yearNow;
    this.handleryear(yearNow);
  },
  data() {
    return {
      table_new_loading: false,
      table_cancel_loading: false,
      table_finish_loading: false,
      month: 0,
      config: { "show-summary": false },
      type: "Cantidad",
      year: 0,
      missingCall: [],
      option: "customerservice",
      types: [
        { value: "vendor", label: "Vendedor" },
        { value: "customerservice", label: "Servicio al Cliente" }
      ],
      columnsNew: [
        {
          prop: "PersonCode",
          label: "Código",
          minWidth: 80,
          fixed: true
        },
        {
          prop: "PersonName",
          label: "Nombre responsable",
          minWidth: 180,
          fixed: true
        },
        {
          prop: "January",
          label: "Enero",
          minWidth: 80,
          fixed: true,
          cellAtrrs: {
            mes: 1,
            tbl: "table_new",
            getType: this.getType,
            OpenSelect: this.OpenSelect
          },
          formatter: CancelHyperLink
        },
        {
          prop: "February",
          label: "Febrero",
          minWidth: 80,
          fixed: true,
          cellAtrrs: {
            mes: 2,
            tbl: "table_new",
            getType: this.getType,
            OpenSelect: this.OpenSelect
          },
          formatter: CancelHyperLink
        },
        {
          prop: "March",
          label: "Marzo",
          minWidth: 80,
          fixed: true,
          cellAtrrs: {
            mes: 3,
            tbl: "table_new",
            getType: this.getType,
            OpenSelect: this.OpenSelect
          },
          formatter: CancelHyperLink
        },
        {
          prop: "April",
          label: "Abril",
          minWidth: 80,
          fixed: true,
          cellAtrrs: {
            mes: 4,
            tbl: "table_new",
            getType: this.getType,
            OpenSelect: this.OpenSelect
          },
          formatter: CancelHyperLink
        },
        {
          prop: "May",
          label: "Mayo",
          minWidth: 80,
          fixed: true,
          cellAtrrs: {
            mes: 5,
            tbl: "table_new",
            getType: this.getType,
            OpenSelect: this.OpenSelect
          },
          formatter: CancelHyperLink
        },
        {
          prop: "June",
          label: "Junio",
          minWidth: 80,
          fixed: true,
          cellAtrrs: {
            mes: 6,
            tbl: "table_new",
            getType: this.getType,
            OpenSelect: this.OpenSelect
          },
          formatter: CancelHyperLink
        },
        {
          prop: "July",
          label: "Julio",
          minWidth: 80,
          fixed: true,
          cellAtrrs: {
            mes: 7,
            tbl: "table_new",
            getType: this.getType,
            OpenSelect: this.OpenSelect
          },
          formatter: CancelHyperLink
        },
        {
          prop: "August",
          label: "Agosto",
          minWidth: 80,
          fixed: true,
          cellAtrrs: {
            mes: 8,
            tbl: "table_new",
            getType: this.getType,
            OpenSelect: this.OpenSelect
          },
          formatter: CancelHyperLink
        },
        {
          prop: "September",
          label: "Septiembre",
          minWidth: 90,
          fixed: true,
          cellAtrrs: {
            mes: 9,
            tbl: "table_new",
            getType: this.getType,
            OpenSelect: this.OpenSelect
          },
          formatter: CancelHyperLink
        },
        {
          prop: "October",
          label: "Octubre",
          minWidth: 80,
          fixed: true,
          cellAtrrs: {
            mes: 10,
            tbl: "table_new",
            getType: this.getType,
            OpenSelect: this.OpenSelect
          },
          formatter: CancelHyperLink
        },
        {
          prop: "November",
          label: "Noviembre",
          minWidth: 90,
          fixed: true,
          cellAtrrs: {
            mes: 11,
            tbl: "table_new",
            getType: this.getType,
            OpenSelect: this.OpenSelect
          },
          formatter: CancelHyperLink
        },
        {
          prop: "December",
          label: "Diciembre",
          minWidth: 80,
          fixed: true,
          cellAtrrs: {
            mes: 12,
            tbl: "table_new",
            getType: this.getType,
            OpenSelect: this.OpenSelect
          },
          formatter: CancelHyperLink
        },
        {
          prop: "Totals",
          label: "Total",
          minWidth: 100,
          fixed: true,
          formatter: (row) => {
            let key = "Totals";
            if (this.getType() === "Monto") {
              key = `${key}Amount`;
            }
            return row[key];
          }
        }
      ]
    };
  },
  methods: {
    formatMonto,
    async handleryear(_year) {
      this.year = _year;
      this.getClientWithoutCalling();
    },

    handlerChanges() {
      this.getClientWithoutCalling();
    },
    OpenSelect(props) {
      this.$refs.detalles.show(props, this.year, this.option);
    },
    getType() {
      return this.type;
    },
    //Maestro de clientes sin llamar
    async getClientWithoutCalling() {
      this.table_new_loading = true;
      this.$http
        .get(
          `/api/customers/ClientWithoutCalling?Year=${this.year}&CompanyId=${this.currentCompany}&Option=${this.option}`,
          {
            timeout: 120000
          }
        )
        .then((response) => {
          if (response.status === 200) {
            this.missingCall = response.data;
          }
        })
        .finally(() => {
          this.table_new_loading = false;
        });
    }
  }
};
</script>

<style scoped>
.box-item {
  padding-left: 2px;
  padding-right: 10px;
}
.item {
  margin-bottom: 18px;
}

.clearfix:before,
.clearfix:after {
  display: table;
  content: "";
}
.clearfix:after {
  clear: both;
}
</style>
